import { Component, ComponentType } from 'react';
import { ConnectDragPreview, ConnectDragSource, DragSource } from 'react-dnd';
import { DnDTypes } from '../../common';
import _, { parseInt, toString } from 'lodash';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';
import SimpleFieldPill, { IOutsideProps } from './simple-field-pill.component';
import { messages, i18nUtils } from '../../i18n';
import { VIZ_SELECTORS } from '../../common/redux/selectors/viz-selectors';
import { SugarIcon } from '../../icons';
import { withTheme } from '@emotion/react';

const DragPreview = props => {
  // probably a better way to do this. assumes that all field pills have same length
  const pillWidth = (
    document.querySelector('.viz-field-pill') as HTMLDivElement
  )?.offsetWidth;
  const { field, shelf, isOverTarget, useFiscalCalendar } = props;
  const isOverTrash = isOverTarget(props.trashTargetId);
  const getTextWidth = () => {
    if (isOverTrash && !_.isNil(shelf)) {
      return `${parseInt(toString(pillWidth)) - 12}px`;
    } else {
      return pillWidth;
    }
  };

  const renderIcon = () => {
    // if hovering over the trash && we have a shelf defined, show the trash icon
    if (isOverTrash && !_.isNil(shelf)) {
      return (
        <SugarIcon
          icon={'trash'}
          hover
          hoverColor={props.theme?.colors?.MediumBlue}
          className={'viz-field-icon small'}
        />
      );
    } else {
      return '';
    }
  };

  const displayName = i18nUtils.translateFieldName(
    messages,
    field,
    useFiscalCalendar,
  );

  return (
    <div style={{ width: pillWidth }} className={'viz-field-pill drag-preview'}>
      <div style={{ width: getTextWidth() }} className={'viz-field-text'}>
        <div className={'viz-field-label'}>{displayName}</div>
      </div>
      {renderIcon()}
    </div>
  );
};
export const FieldPillDragPreview = connect((state: any, ownProps) => {
  const useFiscalCalendar =
    VIZ_SELECTORS.hasVizDatasetFiscalCalendarSetting(state, ownProps) &&
    VIZ_SELECTORS.getActiveVizFiscalSetting(state, ownProps) === 'true';
  return {
    trashTargetId: state.discover.dndTrashTargetId,
    useFiscalCalendar,
  };
})(withTheme(DragPreview));

interface IProps extends IOutsideProps {
  connectDragSource: ConnectDragSource;
  connectDragPreview: ConnectDragPreview;
  isDragging: boolean;
}
class FieldPill extends Component<{ className: string } & IProps> {
  componentDidMount() {
    // hide the default drag preview
    this.props.connectDragPreview(getEmptyImage(), {
      captureDraggingState: true,
    });
  }

  render() {
    return this.props.connectDragSource(
      <div className={`field-pill-drag-wrapper ${this.props.className ?? ''}`}>
        <SimpleFieldPill
          field={this.props.field}
          shelf={this.props.shelf}
          renderFieldDropdown={this.props.renderFieldDropdown}
          isFieldMissing={this.props.isFieldMissing}
          invalid={this.props.invalid}
          iconDataType={this.props.iconDataType}
        />
      </div>,
      { dropEffect: 'move' },
    );
  }
}

const fieldSource = {
  beginDrag(props) {
    return {
      field: props.field,
      shelf: props.shelf,
    };
  },
};
const collect = (connectComponent, monitor) => {
  return {
    connectDragSource: connectComponent.dragSource(),
    connectDragPreview: connectComponent.dragPreview(),
    isDragging: monitor.isDragging(),
  };
};

export default compose(DragSource(DnDTypes.VIZ_FIELD, fieldSource, collect))(
  FieldPill,
) as ComponentType<IOutsideProps>;
